export default __webpack_public_path__ + "static/media/avatar-5.84fc0d44.png";